import * as styles from "./AlertDialogBackdrop.css";

import type { JSX } from "react";

import { AlertDialog as BaseAlertDialog } from "@base-ui/react/alert-dialog";

import type { AlertDialogBackdropProps } from "./AlertDialog.types";

export function AlertDialogBackdrop({
  ...props
}: AlertDialogBackdropProps): JSX.Element {
  return (
    <BaseAlertDialog.Backdrop
      data-slot="alert-dialog-backdrop"
      className={styles.backdrop}
      {...props}
    />
  );
}
